export default "__VITE_ASSET__Dk4zZ3zh__"